import { useSelector } from "react-redux";
import { useGetTransfersList } from "../../lib/hooks";
import PageTitle from "../fragments/PageTitle";

// import Pagination from "./pagination/Pagination";


import classes from './Transfers.module.css'
import TransfersHeader from "./TransfersHeader";
import TransfersRow from "./TransfersRow";
import TransfersFilters from "./TransfersFilters";
import MockRows from "../mock/MockRows";
import { transfers_table_header_cells } from "../../assets/data";
import Pagination from '../work_queues/pages/pagination/Pagination'

export default function Transfers() {
    const loading = useSelector(state => state.transfers.loading)
    const snapshot = useSelector(state => state.transfers.snapshotData)
    const patientsList =  useSelector(state => state.transfers.currentpagedata)

    // get the referrals list from the hook 
    useGetTransfersList()
console.log('patientsList', patientsList)
    return <>
        <div className={classes.header_box}>
            <PageTitle isContainer={true}>Transfers</PageTitle>    
            <TransfersFilters />
        </div>
        <table>
            <TransfersHeader/>
            {loading && !snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                <MockRows numberOfRows={transfers_table_header_cells.length}/>
            </tbody>}
            {loading && snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                {snapshot.data.map((item, index) => (
                    <TransfersRow key={item.id} data={item} index={index}/>
                ))}
            </tbody>}
            {!loading && patientsList && patientsList.data && <tbody>
                {patientsList.data.map((item, index) => (
                    <TransfersRow key={item.id} data={item} index={index} classes={classes}/>
                ))}    
            </tbody>}    
            {!loading && !patientsList && <tbody>
                <tr>
                    <td colSpan={transfers_table_header_cells.length}>No items found</td>    
                </tr> 
            </tbody>}         
        </table>

        {patientsList && patientsList.meta && <div className={classes.pagination_container}>
            {patientsList  && <Pagination data={patientsList} apiType='transfers' hidePerPage={true} />}
        </div>}
    </>
}